/* @ngInject */
export default function ReportFormHeaderCtrl(
  ReportsManager,
  PageLevelManager,
) {
  const vm = this;
  vm.report = ReportsManager.report;
  vm.PageLevelManager = PageLevelManager;
}
